<template>
  <Plan
    is-highlighted
    title="Pro"
    description="Get all of the free plan plus access to amazing features and
                    three profiles."
    :price="price"
    :price-description="`USD per ${interval}`"
    :features="FEATURES"
  >
    <template v-if="!$slots.actions" #actions>
      <slot name="actions" />
    </template>

    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />
  </Plan>
</template>

<script>
import Plan from './plan';

const FEATURES = [
  {
    title: 'All of the free features',
  },
  {
    title: 'Powerful and versatile link types to keep your content fresh',
  },
  {
    title: 'In-depth analytics to track views, clicks, referral, geo and more',
  },
  {
    title:
      'Unlock premium integrations like Opt-in forms, Forms, Tracking Pixels, and more',
  },
  {
    title: 'Add your own domain to your profile for a custom URL',
  },
];

export default {
  components: {
    Plan,
  },

  props: {
    price: {
      type: String,
      required: true,
    },

    interval: {
      type: String,
      default: 'month',
    },
  },

  setup() {
    return {
      FEATURES,
    };
  },
};
</script>

<style lang="scss" scoped></style>
